import { adminHttpClient } from '../../../commons/adminHttpClient'
import localStorage from '../../../commons/localStorage'
import { Plan, BudgetGoal } from '../state'

export type Question6Values = BudgetGoal & {
  id: string
}

const question6Api = (values: Question6Values): Promise<any> => {
  const code = localStorage.getProspectSignupCode()

  return adminHttpClient.put('/IchraDecisionTool/ProspectApplication/Step2/Question6', {
    token: code,
    budgetGoals: [{ ...values, id: values.id }],
  })
}

export default question6Api
